import React, { Component } from 'react';
import './Cancel.css';
export class Cancel extends Component {
   
    render() {
        return (
            <div className="mainbody">
                <div className="cards">
                    <div style={{ borderRadius: '200px', height: '200px', width: '200px', background: '#F8FAF5', margin: '0 auto' }}>
                        <i style={{ color: 'darkred' }} className="checkmark">❌</i>
                    </div>
                    <h1 style={{ color: 'darkred' }}>Cancel</h1>
                    <p>We received your cancel request;<br /> </p>
                </div>
            </div>
        );
    }
}    